import ConfirmDialog from "@/components/confirm-dialog/ConfirmDialog";
import ToolbarButton from "@/components/ToolbarButton";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { cn } from "@/lib/utils";
import { Eraser } from "lucide-react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ClearButtonProps {
  className?: string;
  labelClassName?: string;
}

export default function ClearButton({
  className,
  labelClassName,
}: ClearButtonProps) {
  const { t } = useTranslation();
  const survey = useSurvey();

  const { isSubmitting, disabled } = useFormState();

  const onConfirm = () => {
    survey.handleCleanSchema();
  };

  return (
    <ConfirmDialog
      title={t("surveyEditor.clearDialog.title")}
      yesLabel={t("surveyEditor.clearDialog.yesButton")}
      noLabel={t("surveyEditor.clearDialog.noButton")}
      content={t("surveyEditor.clearDialog.content")}
      onConfirm={onConfirm}
    >
      <ToolbarButton
        type="button"
        className={className}
        disabled={isSubmitting || disabled}
      >
        <Eraser className="w-5 h-5" />
        <span className={cn("ml-3", labelClassName)}>
          {t("surveyEditor.toolbar.clear")}
        </span>
      </ToolbarButton>
    </ConfirmDialog>
  );
}
